import React from "react";
import { Route } from "react-router-dom";

import SPSession01Burnstein from "../substratum-protocol/SPSession01-Burnstein";
import SPSession01Moshe from "../substratum-protocol/SPSession01-Moshe";
import SPSession01 from "../substratum-protocol/SPSession01";
import SPSession02 from "../substratum-protocol/SPSession02";
import SPSession03 from "../substratum-protocol/SPSession03";

const SubstratumProtocolRoutes = () => {
  return [
    <Route
      path="/substratum-protocol-scientist-profile-burnstein-grok"
      element={<SPSession01Burnstein />}
    />,
    <Route
      path="/substratum-protocol-scientist-profile-moshe-mazel"
      element={<SPSession01Moshe />}
    />,
    <Route path="/substratum-protocol-session-01" element={<SPSession01 />} />,
    <Route path="/substratum-protocol-session-02" element={<SPSession02 />} />,
    <Route path="/substratum-protocol-session-03" element={<SPSession03 />} />,
  ];
};

export default SubstratumProtocolRoutes;
